import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useInfiniteQuery } from "react-query";
import { PrevisaoOrcamentaria, PrevisaoOrcamentariaParams } from "../typings";

export default function usePrevisaoOrcamentaria(
  query: PrevisaoOrcamentariaParams
) {
  return useInfiniteQuery<PaginateResult<PrevisaoOrcamentaria>, AxiosError>(
    [`/v1/previsao-orcamentaria`, query],
    async ({ pageParam }) => {
      const { data } = await http.get<PaginateResult<PrevisaoOrcamentaria>>(
        "/v1/previsao-orcamentaria",
        {
          params: { ...query, page: pageParam },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}
